/* eslint-disable no-undef */
// FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faEdit,
  faEraser,
  faEye,
  faInfo,
  faPencilAlt,
  faPlus,
  faRedo,
  faSave,
  faSearch,
  faSync,
  faTimesCircle,
  faTrash,
  faUndo,
  faUnlink,
} from '@fortawesome/free-solid-svg-icons';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Layout } from 'antd';
import { AuthWrapper } from 'components/auth';
import { Provider } from 'jotai';
import { useMaintenanceApiListener } from 'pages/maintenance/models/use-maintenance-api-listener';
import { Suspense } from 'react';
import './App.css';
import './assets/global.scss';
import { AppRouter } from './router';

// ADD FONTAWESOME ICONS LIBRARY

library.add(
  faSync,
  faTrash,
  faPencilAlt,
  faEye,
  faInfo,
  faSearch,
  faChevronDown,
  faChevronUp,
  faSave,
  faPlus,
  faUndo,
  faEraser,
  faEdit,
  faCheckCircle,
  faTimesCircle,
  faCheck,
  faRedo,
  faArrowRight,
  faUnlink
);

const { Content } = Layout;

const MaintenanceApiListener = () => {
  useMaintenanceApiListener();
  return null;
};

function ReactApp() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
      },
    },
    queryCache: new QueryCache({
      onError: async () => {},
    }),
    mutationCache: new MutationCache({
      onError: async () => {},
    }),
  });

  return (
    <Layout>
      <Content>
        <QueryClientProvider client={queryClient}>
          <MaintenanceApiListener />
          <Provider>
            <AuthWrapper>
              <Suspense fallback={<div>Laden...</div>}>
                <AppRouter />
                <ReactQueryDevtools initialIsOpen={false} />
              </Suspense>
            </AuthWrapper>
          </Provider>
        </QueryClientProvider>
      </Content>
    </Layout>
  );
}

export default ReactApp;
